import { useRef } from "react";
/** Use when you want to use a callback in an effect that may change,
 * but you don't care and just want to use whatever the last currently
 * passed function is. */
export const useCallbackRef = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    return callbackRef;
};
